module.exports = __webpack_public_path__ + "assets/img/banner.c5693d1f.jpg";